<tp-modal [dialogTitle]="(dialogTitle$ | async) ?? 'Disable MFA'" [isBusy]="isSubmitting$ | async">
  @if (reauthRequired) {
    <tp-reauthenticate
      reauthAction="disable multi-factor authentication"
      [isSubmitting$]="isSubmitting$"
      (reauthStageChanged)="reauthStageChanged($event)"
    ></tp-reauthenticate>
  } @else {
    <p>Are you sure you want to disable multi-factor authentication? Doing so will leave your account less secure.</p>
    <tp-form-actions
      submitText="Disable MFA" submitButtonStyle="primary-outline red stroke"
      buttonIdPrefix="disableMFAModal"
      [isSubmitting]="isSubmitting$ | async" (submitClick)="disableMFA()" [cancellable]="true" (cancel)="close()"
    />
  }
</tp-modal>
